export default function liveOperate (to){
	console.log('to',to);
    if (['home','projectGuide'].indexOf(to.name) > -1) {
		console.log('111111111111');
		let live800none = document.getElementById('live800none')
		let live800block = document.getElementById('live800block')
		let styleNode = document.createElement("style");
		styleNode.setAttribute("type", "text/css");
		styleNode.setAttribute("id", "live800none");
		styleNode.innerHTML = `
#live800_chat_nav,#Live800_chatTip_iframe,#live800_chatBox{
    visibility: hidden!important;
}
`;
		console.log('live800none', live800none);
		console.log('live800block', live800block);
		if (!live800none) {
			document.head.appendChild(styleNode)
		}
		if (live800block) {
			live800block.parentNode.removeChild(live800block)
		}
	} else {
		let live800none = document.getElementById('live800none')
		let live800block = document.getElementById('live800block')
		let styleNode = document.createElement("style");
		styleNode.setAttribute("type", "text/css");
		styleNode.setAttribute("id", "live800block");
		styleNode.innerHTML = `
#live800_chat_nav,#Live800_chatTip_iframe,#live800_chatBox{
    visibility: visible!important;
}
`;
		if (!live800block) {
			document.head.appendChild(styleNode)
		}
		if (live800none) {
			live800none.parentNode.removeChild(live800none)
		}

	}
}